"use client";
import { jsxs as m, Fragment as k, jsx as e } from "react/jsx-runtime";
import { Slot as I } from "@radix-ui/react-slot";
import { Root as A, Action as R, Close as j, Viewport as p, Provider as z } from "@radix-ui/react-toast";
import { cva as u } from "class-variance-authority";
import * as x from "react";
import { Close as M, Microphone as P, InformationCircle as S, CheckCircle as W, WarningCircle as g } from "@videoblocks/react-icons";
import { Text as $ } from "../Text/Text.mjs";
import { cn as i } from "../../../utils/utils.mjs";
const D = u(
  "flex p-6 justify-between items-start rounded-sm border-l-8 shadow-level3-soft data-[state=open]:animate-in data-[state=open]:slide-in-from-right",
  {
    variants: {
      variant: {
        error: "border-l-red-500 bg-red-100 text-red-500",
        warning: "border-l-orange-500 bg-orange-100 text-orange-500",
        success: "border-l-green-500 bg-green-100 text-green-500",
        info: "border-l-blue-500 bg-blue-100 text-blue-500",
        neutral: "border-l-gray-500 bg-gray-200 text-black"
      }
    }
  }
), b = u("", {
  variants: {
    variant: {
      error: "fill-red-500",
      warning: "fill-orange-500",
      success: "fill-green-500",
      info: "fill-blue-500",
      neutral: "fill-black"
    }
  }
}), F = {
  error: g,
  warning: g,
  success: W,
  info: S,
  neutral: P
}, q = (t, r) => {
  const a = t || "neutral", o = F[a], l = /* @__PURE__ */ e(
    o,
    {
      "data-testid": `default-icon-${a}`,
      className: i("size-6", b({ variant: a }))
    }
  );
  return r || l;
}, B = x.forwardRef(
  ({
    actionAltText: t,
    asChild: r = !1,
    hasClose: a = !0,
    icon: o = null,
    actionProps: l = {},
    children: c,
    className: v = "",
    duration: h = 2e4,
    title: n,
    variant: s = "neutral",
    viewportClassName: f,
    viewportProps: d,
    ...w
  }, N) => {
    const C = r ? I : "a", { altText: T, ...V } = l, y = t || T || "";
    return /* @__PURE__ */ m(k, { children: [
      /* @__PURE__ */ e(
        A,
        {
          className: i(D({ variant: s }), v),
          duration: h,
          "data-variant": s,
          role: "status",
          ...w,
          children: /* @__PURE__ */ m("div", { className: "flex items-center gap-3 flex-1", children: [
            /* @__PURE__ */ e("div", { className: "flex-shrink-0", children: q(s, o) }),
            typeof n == "string" && n ? /* @__PURE__ */ e($, { fontSize: "sm", fontWeight: "regular", children: n }) : n,
            c && /* @__PURE__ */ e(
              R,
              {
                ref: N,
                className: "text-sm font-bold underline hover:no-underline cursor-pointer",
                altText: y,
                asChild: r,
                ...V,
                children: /* @__PURE__ */ e(C, { children: c })
              }
            ),
            a && /* @__PURE__ */ e(
              j,
              {
                className: "flex-shrink-0 p-1 hover:bg-gray-100 hover:cursor-pointer rounded transition-colors ml-auto",
                "aria-label": "Close",
                children: /* @__PURE__ */ e(M, { className: i("w-3 h-3", b({ variant: s })) })
              }
            )
          ] })
        }
      ),
      (f || d) && /* @__PURE__ */ e(p, { className: f, ...d })
    ] });
  }
);
B.displayName = "Toast";
const E = x.forwardRef(({ className: t, ...r }, a) => /* @__PURE__ */ e(p, { ref: a, className: i("fixed top-[var(--spacing-24)] right-[var(--spacing-6)] flex flex-col gap-[var(--spacing-2)] w-[var(--breakpoint-sm)] max-w-[calc(100vw-var(--spacing-12))] m-0 list-none z-[1050] outline-none", t), ...r }));
E.displayName = "ToastViewport";
const U = ({ children: t, ...r }) => /* @__PURE__ */ e(z, { swipeDirection: "right", ...r, children: t });
export {
  B as Toast,
  U as ToastProvider,
  E as ToastViewport
};
